/*
 *   File : gradient.js
 *   Author URI : https://evoqins.com
 *   Description : Gradient button for site
 *   Integrations : null
 *   Version : v1.1
 */

/*import styles*/
import style from "../../Styles/Components/gradient.module.scss";

const GradientButton = ({
    onPress = () => { },
    className = '',
    cancel = null,
    toggle = null,
    target = null,
    disabled = false,
    loading = false,
    type = '',
    id = null,
    label = "",
    hide_loader = false,
}) => {
    return (
        // Gradient button
        <button className={disabled === false ?
            `${style.e_active_btn} ${className}  padding-12px-tb  padding-24px-left padding-10px-right  e-poppins-medium e-font-16 bg-prime-gradient color-white border-radius-6px no-border cursor-pointer`
            : `${style.e_inactive_btn} ${className} padding-12px-tb padding-24px-left padding-10px-right   e-poppins-medium e-font-14 bg-prime-gradient color-white border-radius-6px no-border`}
            id={id}
            type={type ? type : "submit"}
            style={{ width: type === 1 ? "100%" : null }}
            data-bs-toggle={toggle}
            data-loading={`${loading}`}
            data-bs-target={target}
            data-bs-dismiss={cancel}
            onClick={onPress}
        >
            <span className="position-relative d-flex justify-content-center w-max-content  m-auto align-items-center line-height-24px">
                {label ? label : "Submit"}
                {hide_loader === true ?
                    null
                    :
                    loading === true ? (
                        <img draggable={false} src={require('../../Assets/Images/mt-wealth-button-loader.gif')}
                            className={`${style.loader_gif}`} />
                    )
                        :
                        (
                            <img draggable={false} src={require('../../Assets/Images/mt-wealth-button-loader.gif')}
                                className={`${style.loader_gif} opacity-0`} />
                        )
                }
            </span>
        </button>
    );
};


export default GradientButton;
